import { Box } from "@mui/material";
import { CustomInput, CustomSelect } from "../../../components-new/common";
import { useDispatch, useSelector } from "react-redux";
import { setEditStep } from "../../../Redux/TestAuthoring/TestAuthoring";
import { extractoption } from "../constants";
let options = {
  regex: ["Regex"],
  SubString: ["Start", "End"],
};
const TestDataProcessing = ({ item }) => {
  const dispatch = useDispatch();
  const obj = item.testProcessingobj ?? {
    Regex: "",
    Start: "",
    End: "",
  };
  return (
    <Box display="flex" flexDirection="column" sx={{ ml: 3 }}>
      <CustomSelect
        label="Extract"
        options={extractoption}
        width="50%"
        background="#ffffff"
        value={item.testProcessingtype || ""}
        onChange={(e) => dispatch(setEditStep({ ...item, ["testProcessingtype"]: e.target.value }))}
      />

      {item.testProcessingtype &&
        options[item.testProcessingtype]?.map((label) => (
          <CustomInput
            key={label}
            label={label}
            placeholder={`Enter ${label.toLowerCase()}`}
            value={obj[label] || ""}
            sx={{ mt: 3, width: "100%" }}
            onChange={(e) => {
              dispatch(
                setEditStep({
                  ...item,
                  testProcessingobj: { ...obj, [label]: e.target.value },
                }),
              );
            }}
          />
        ))}
    </Box>
  );
};

export default TestDataProcessing;
